import React from "react";
import { lib, event } from "../../index";
import { Button, message, Space } from "antd";
import { SearchList } from "../../config-center-v3";
import axios from "axios";
import DeptAddUserModal from "./dept-add-user-modal";
import DeptUserCancelPermissionModal from "./dept-user-cancel-permission-modal";
import HOC from "../../util/HOC";

@HOC.mapAuthButtonsToState({
    pagePath: "/dept-manage",
    buttonCodeArr: ["batchCancelPermission", "cancelPermission", "userAdd"],
})
export default class DeptAddUser extends SearchList {
    constructor(props) {
        super(props);
        this.state.buttons = [];
    }

    getConfig() {
        return Promise.resolve({
            page: {
                api: "/ucenter-admin/dept/user/page",
                bordered: true,
                isBatch: true, // 启用批量选择功能
            },
            searchKeyList: [
                {
                    id: 1,
                    label: "用户名",
                    key: "userName",
                    type: "input",
                    extra: "",
                },
                {
                    id: 2,
                    label: "姓名",
                    key: "nickName",
                    type: "input",
                    extra: "",
                },
                {
                    id: 3,
                    label: "手机号",
                    key: "mobile",
                    type: "input",
                    extra: "",
                },
            ],
            tableFieldList: [
                {
                    id: 1,
                    title: "用户名",
                    key: "userName",
                    width: 150,
                    fixed: "show",
                },
                {
                    id: 3,
                    title: "手机号",
                    key: "mobile",
                    width: 130,
                    fixed: "show",
                },
                {
                    id: 4,
                    title: "工号",
                    key: "id",
                    width: 120,
                    fixed: "show",
                },
                {
                    id: 5,
                    title: "创建时间",
                    key: "createTime",
                    width: 150,
                    fixed: "show",
                },
                {
                    id: 6,
                    title: "操作",
                    key: "myOperation",
                    type: "function",
                    width: 120,
                    fixed: "right",
                },
            ],
        });
    }

    configLoadDefaultParams() {
        return {
            systemCode: lib.config.systemCode,
            departmentId: lib.getParam("departmentId"),
        };
    }

    reload() {
        this.load(true);
    }

    renderOperationTopView() {
        return (
            <Space>
                {
                    <Button type={"primary"} onClick={() => this.batchCancelPermission()}>
                        批量取消绑定
                    </Button>
                }
                <span>
                    当前部门【{lib.getParam("deptName")}】已绑定{this.state.pagination.totalCount ?? "0"}名人员
                </span>
            </Space>
        );
    }

    renderRightOperation() {
        return (
            <Space>
                {
                    <Button type={"primary"} onClick={() => this.setState({ addModalVisible: true })}>
                        添加人员
                    </Button>
                }
            </Space>
        );
    }

    cancelPermission(row) {
        this.setState({
            cancelRow: [row],
            cancelPermissionModalVisible: true,
        });
    }

    batchCancelPermission() {
        const selectedRows = this.state.selectedRows;
        if (selectedRows?.length) {
            this.setState({
                cancelRow: selectedRows,
                cancelPermissionModalVisible: true,
            });
        } else {
            message.warn("请选择至少一条数据");
        }
    }

    myOperation(row) {
        return (
            <Space>
                {true && (
                    <Button type={"link"} onClick={() => this.cancelPermission(row)}>
                        移除
                    </Button>
                )}
            </Space>
        );
    }

    renderModal() {
        const { addModalVisible, cancelPermissionModalVisible } = this.state;

        return (
            <>
                <DeptAddUserModal
                    departmentId={lib.getParam("departmentId")}
                    visible={addModalVisible}
                    onClose={success => {
                        this.setState({
                            selectedRows: [],
                            selectedIdList: [],
                            addModalVisible: false,
                        });
                        if (success) {
                            event.emit(lib.getParam("refresh_event"), {});
                            this.reload();
                        }
                    }}
                />
                <DeptUserCancelPermissionModal
                    departmentId={lib.getParam("departmentId")}
                    deptName={lib.getParam("deptName")}
                    cancelRow={this.state.cancelRow}
                    visible={cancelPermissionModalVisible}
                    onClose={success => {
                        this.setState({
                            cancelPermissionModalVisible: false,
                            selectedRows: [],
                            selectedIdList: [],
                            cancelRow: [],
                        });
                        if (success) {
                            event.emit(lib.getParam("refresh_event"), {});
                            this.reload();
                        }
                    }}
                />
            </>
        );
    }
}
